/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthResponse,
  CheckPassword,
  CreatedTotpMfaMethod,
  Credentials,
  DevicePatch,
  DeviceResponse,
  ErrorResponse,
  GetMfaMethodsParams,
  HTTPValidationError,
  InitCustomExceptionCustomAccountInactiveSchema,
  InitCustomExceptionCustomInvalidTokenSchema,
  MfaMethod,
  MfaMethodEmailCreate,
  MfaMethodPatch,
  MfaMethodTotpCreate,
  PasswordChange,
  PasswordChangeWithCode,
  PasswordPolicy,
  PreAuthResponse,
  ResetMfaParams,
  SendPasswordResetCodeParams,
  StartEmailChallengeRequest,
  VerifiedEnrollmentResponse,
  VerifyBackupCodeRequest,
  VerifyChallengeRequest,
  VerifyCodeRequest,
  VerifyLoginEmailChallengeRequest,
  VerifyLoginTotpRequest,
  VerifyTotpMfaMethodRequest
} from '../model';

import {
  apiBase
} from '@/lib/apiBase.ts';

import { customInstance } from '../../lib/customApiInstance';
import type { ErrorType , BodyType } from '../../lib/customApiInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Login
 */
export const login = (
    credentials: BodyType<Credentials>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse | PreAuthResponse>(
      {url: `${apiBase()}/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: credentials, signal
    },
      options);
    }




export const getLoginMutationOptions = <TError = ErrorType<ErrorResponse | HTTPValidationError | InitCustomExceptionCustomAccountInactiveSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<Credentials>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<Credentials>}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: BodyType<Credentials>}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = BodyType<Credentials>
    export type LoginMutationError = ErrorType<ErrorResponse | HTTPValidationError | InitCustomExceptionCustomAccountInactiveSchema>

    /**
 * @summary Login
 */
export const useLogin = <TError = ErrorType<ErrorResponse | HTTPValidationError | InitCustomExceptionCustomAccountInactiveSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<Credentials>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: BodyType<Credentials>},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }
    /**
 * @summary Check Password
 */
export const checkPassword = (
    checkPasswordBody: BodyType<CheckPassword>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `${apiBase()}/auth/check_password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkPasswordBody, signal
    },
      options);
    }




export const getCheckPasswordMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkPassword>>, TError,{data: BodyType<CheckPassword>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof checkPassword>>, TError,{data: BodyType<CheckPassword>}, TContext> => {

const mutationKey = ['checkPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkPassword>>, {data: BodyType<CheckPassword>}> = (props) => {
          const {data} = props ?? {};

          return  checkPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof checkPassword>>>
    export type CheckPasswordMutationBody = BodyType<CheckPassword>
    export type CheckPasswordMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Check Password
 */
export const useCheckPassword = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkPassword>>, TError,{data: BodyType<CheckPassword>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkPassword>>,
        TError,
        {data: BodyType<CheckPassword>},
        TContext
      > => {
      return useMutation(getCheckPasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Password Policy
 */
export const getPasswordPolicy = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PasswordPolicy>(
      {url: `${apiBase()}/auth/password_policy`, method: 'GET', signal
    },
      options);
    }




export const getGetPasswordPolicyQueryKey = () => {
    return [
    `${apiBase()}/auth/password_policy`
    ] as const;
    }


export const getGetPasswordPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getPasswordPolicy>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPasswordPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPasswordPolicy>>> = ({ signal }) => getPasswordPolicy(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPasswordPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPasswordPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getPasswordPolicy>>>
export type GetPasswordPolicyQueryError = ErrorType<unknown>


export function useGetPasswordPolicy<TData = Awaited<ReturnType<typeof getPasswordPolicy>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPasswordPolicy>>,
          TError,
          Awaited<ReturnType<typeof getPasswordPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPasswordPolicy<TData = Awaited<ReturnType<typeof getPasswordPolicy>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPasswordPolicy>>,
          TError,
          Awaited<ReturnType<typeof getPasswordPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPasswordPolicy<TData = Awaited<ReturnType<typeof getPasswordPolicy>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Password Policy
 */

export function useGetPasswordPolicy<TData = Awaited<ReturnType<typeof getPasswordPolicy>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPasswordPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Change Password
 */
export const changePassword = (
    passwordChange: BodyType<PasswordChange>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordChange, signal
    },
      options);
    }




export const getChangePasswordMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: BodyType<PasswordChange>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: BodyType<PasswordChange>}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: BodyType<PasswordChange>}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = BodyType<PasswordChange>
    export type ChangePasswordMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Change Password
 */
export const useChangePassword = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: BodyType<PasswordChange>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: BodyType<PasswordChange>},
        TContext
      > => {
      return useMutation(getChangePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Refresh
 */
export const refresh = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/refresh`, method: 'POST', signal
    },
      options);
    }




export const getRefreshMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | InitCustomExceptionCustomAccountInactiveSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext> => {

const mutationKey = ['refresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refresh>>, void> = () => {


          return  refresh(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshMutationResult = NonNullable<Awaited<ReturnType<typeof refresh>>>

    export type RefreshMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | InitCustomExceptionCustomAccountInactiveSchema>

    /**
 * @summary Refresh
 */
export const useRefresh = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | InitCustomExceptionCustomAccountInactiveSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refresh>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshMutationOptions(options), queryClient);
    }
    /**
 * @summary Change Password With Code
 */
export const changePasswordWithCode = (
    passwordChangeWithCode: BodyType<PasswordChangeWithCode>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `${apiBase()}/auth/change_password_with_code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordChangeWithCode, signal
    },
      options);
    }




export const getChangePasswordWithCodeMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePasswordWithCode>>, TError,{data: BodyType<PasswordChangeWithCode>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePasswordWithCode>>, TError,{data: BodyType<PasswordChangeWithCode>}, TContext> => {

const mutationKey = ['changePasswordWithCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePasswordWithCode>>, {data: BodyType<PasswordChangeWithCode>}> = (props) => {
          const {data} = props ?? {};

          return  changePasswordWithCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordWithCodeMutationResult = NonNullable<Awaited<ReturnType<typeof changePasswordWithCode>>>
    export type ChangePasswordWithCodeMutationBody = BodyType<PasswordChangeWithCode>
    export type ChangePasswordWithCodeMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Change Password With Code
 */
export const useChangePasswordWithCode = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePasswordWithCode>>, TError,{data: BodyType<PasswordChangeWithCode>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePasswordWithCode>>,
        TError,
        {data: BodyType<PasswordChangeWithCode>},
        TContext
      > => {
      return useMutation(getChangePasswordWithCodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Password Reset Code Is Valid
 */
export const passwordResetCodeIsValid = (
    verifyCodeRequest: BodyType<VerifyCodeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `${apiBase()}/auth/password_reset_code_is_valid`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyCodeRequest, signal
    },
      options);
    }




export const getPasswordResetCodeIsValidMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordResetCodeIsValid>>, TError,{data: BodyType<VerifyCodeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof passwordResetCodeIsValid>>, TError,{data: BodyType<VerifyCodeRequest>}, TContext> => {

const mutationKey = ['passwordResetCodeIsValid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof passwordResetCodeIsValid>>, {data: BodyType<VerifyCodeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  passwordResetCodeIsValid(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PasswordResetCodeIsValidMutationResult = NonNullable<Awaited<ReturnType<typeof passwordResetCodeIsValid>>>
    export type PasswordResetCodeIsValidMutationBody = BodyType<VerifyCodeRequest>
    export type PasswordResetCodeIsValidMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Password Reset Code Is Valid
 */
export const usePasswordResetCodeIsValid = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordResetCodeIsValid>>, TError,{data: BodyType<VerifyCodeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof passwordResetCodeIsValid>>,
        TError,
        {data: BodyType<VerifyCodeRequest>},
        TContext
      > => {
      return useMutation(getPasswordResetCodeIsValidMutationOptions(options), queryClient);
    }
    /**
 * @summary Send Password Reset Code
 */
export const sendPasswordResetCode = (
    params: SendPasswordResetCodeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `${apiBase()}/auth/send_password_reset_code`, method: 'POST',
        params, signal
    },
      options);
    }




export const getSendPasswordResetCodeMutationOptions = <TError = ErrorType<HTTPValidationError | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPasswordResetCode>>, TError,{params: SendPasswordResetCodeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPasswordResetCode>>, TError,{params: SendPasswordResetCodeParams}, TContext> => {

const mutationKey = ['sendPasswordResetCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPasswordResetCode>>, {params: SendPasswordResetCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  sendPasswordResetCode(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPasswordResetCodeMutationResult = NonNullable<Awaited<ReturnType<typeof sendPasswordResetCode>>>

    export type SendPasswordResetCodeMutationError = ErrorType<HTTPValidationError | ErrorResponse>

    /**
 * @summary Send Password Reset Code
 */
export const useSendPasswordResetCode = <TError = ErrorType<HTTPValidationError | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPasswordResetCode>>, TError,{params: SendPasswordResetCodeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPasswordResetCode>>,
        TError,
        {params: SendPasswordResetCodeParams},
        TContext
      > => {
      return useMutation(getSendPasswordResetCodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Mfa Methods
 */
export const getMfaMethods = (
    params?: GetMfaMethodsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MfaMethod[]>(
      {url: `${apiBase()}/auth/mfa/method`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetMfaMethodsQueryKey = (params?: GetMfaMethodsParams,) => {
    return [
    `${apiBase()}/auth/mfa/method`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMfaMethodsQueryOptions = <TData = Awaited<ReturnType<typeof getMfaMethods>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>>(params?: GetMfaMethodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMfaMethodsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMfaMethods>>> = ({ signal }) => getMfaMethods(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMfaMethods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMfaMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof getMfaMethods>>>
export type GetMfaMethodsQueryError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>


export function useGetMfaMethods<TData = Awaited<ReturnType<typeof getMfaMethods>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>>(
 params: undefined |  GetMfaMethodsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaMethods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMfaMethods>>,
          TError,
          Awaited<ReturnType<typeof getMfaMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMfaMethods<TData = Awaited<ReturnType<typeof getMfaMethods>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>>(
 params?: GetMfaMethodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaMethods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMfaMethods>>,
          TError,
          Awaited<ReturnType<typeof getMfaMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMfaMethods<TData = Awaited<ReturnType<typeof getMfaMethods>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>>(
 params?: GetMfaMethodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mfa Methods
 */

export function useGetMfaMethods<TData = Awaited<ReturnType<typeof getMfaMethods>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>>(
 params?: GetMfaMethodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMfaMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMfaMethodsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create Totp Mfa Method
 */
export const createTotpMfaMethod = (
    mfaMethodTotpCreate: BodyType<MfaMethodTotpCreate>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreatedTotpMfaMethod>(
      {url: `${apiBase()}/auth/mfa/method/totp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mfaMethodTotpCreate, signal
    },
      options);
    }




export const getCreateTotpMfaMethodMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTotpMfaMethod>>, TError,{data: BodyType<MfaMethodTotpCreate>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTotpMfaMethod>>, TError,{data: BodyType<MfaMethodTotpCreate>}, TContext> => {

const mutationKey = ['createTotpMfaMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTotpMfaMethod>>, {data: BodyType<MfaMethodTotpCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createTotpMfaMethod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTotpMfaMethodMutationResult = NonNullable<Awaited<ReturnType<typeof createTotpMfaMethod>>>
    export type CreateTotpMfaMethodMutationBody = BodyType<MfaMethodTotpCreate>
    export type CreateTotpMfaMethodMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Create Totp Mfa Method
 */
export const useCreateTotpMfaMethod = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTotpMfaMethod>>, TError,{data: BodyType<MfaMethodTotpCreate>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTotpMfaMethod>>,
        TError,
        {data: BodyType<MfaMethodTotpCreate>},
        TContext
      > => {
      return useMutation(getCreateTotpMfaMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify Mfa Totp Method
 */
export const verifyMfaTotpMethod = (
    mfaMethodId: string,
    verifyTotpMfaMethodRequest: BodyType<VerifyTotpMfaMethodRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VerifiedEnrollmentResponse>(
      {url: `${apiBase()}/auth/mfa/method/${mfaMethodId}/verify/totp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyTotpMfaMethodRequest, signal
    },
      options);
    }




export const getVerifyMfaTotpMethodMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfaTotpMethod>>, TError,{mfaMethodId: string;data: BodyType<VerifyTotpMfaMethodRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMfaTotpMethod>>, TError,{mfaMethodId: string;data: BodyType<VerifyTotpMfaMethodRequest>}, TContext> => {

const mutationKey = ['verifyMfaTotpMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMfaTotpMethod>>, {mfaMethodId: string;data: BodyType<VerifyTotpMfaMethodRequest>}> = (props) => {
          const {mfaMethodId,data} = props ?? {};

          return  verifyMfaTotpMethod(mfaMethodId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMfaTotpMethodMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMfaTotpMethod>>>
    export type VerifyMfaTotpMethodMutationBody = BodyType<VerifyTotpMfaMethodRequest>
    export type VerifyMfaTotpMethodMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Verify Mfa Totp Method
 */
export const useVerifyMfaTotpMethod = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfaTotpMethod>>, TError,{mfaMethodId: string;data: BodyType<VerifyTotpMfaMethodRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyMfaTotpMethod>>,
        TError,
        {mfaMethodId: string;data: BodyType<VerifyTotpMfaMethodRequest>},
        TContext
      > => {
      return useMutation(getVerifyMfaTotpMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Patch Mfa Method
 */
export const patchMfaMethod = (
    mfaMethodId: string,
    mfaMethodPatch: BodyType<MfaMethodPatch>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MfaMethod>(
      {url: `${apiBase()}/auth/mfa/method/${mfaMethodId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: mfaMethodPatch, signal
    },
      options);
    }




export const getPatchMfaMethodMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMfaMethod>>, TError,{mfaMethodId: string;data: BodyType<MfaMethodPatch>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMfaMethod>>, TError,{mfaMethodId: string;data: BodyType<MfaMethodPatch>}, TContext> => {

const mutationKey = ['patchMfaMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMfaMethod>>, {mfaMethodId: string;data: BodyType<MfaMethodPatch>}> = (props) => {
          const {mfaMethodId,data} = props ?? {};

          return  patchMfaMethod(mfaMethodId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchMfaMethodMutationResult = NonNullable<Awaited<ReturnType<typeof patchMfaMethod>>>
    export type PatchMfaMethodMutationBody = BodyType<MfaMethodPatch>
    export type PatchMfaMethodMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Patch Mfa Method
 */
export const usePatchMfaMethod = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMfaMethod>>, TError,{mfaMethodId: string;data: BodyType<MfaMethodPatch>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMfaMethod>>,
        TError,
        {mfaMethodId: string;data: BodyType<MfaMethodPatch>},
        TContext
      > => {
      return useMutation(getPatchMfaMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Mfa Method
 */
export const deleteMfaMethod = (
    mfaMethodId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `${apiBase()}/auth/mfa/method/${mfaMethodId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMfaMethodMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMfaMethod>>, TError,{mfaMethodId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMfaMethod>>, TError,{mfaMethodId: string}, TContext> => {

const mutationKey = ['deleteMfaMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMfaMethod>>, {mfaMethodId: string}> = (props) => {
          const {mfaMethodId} = props ?? {};

          return  deleteMfaMethod(mfaMethodId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMfaMethodMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMfaMethod>>>

    export type DeleteMfaMethodMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Delete Mfa Method
 */
export const useDeleteMfaMethod = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMfaMethod>>, TError,{mfaMethodId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMfaMethod>>,
        TError,
        {mfaMethodId: string},
        TContext
      > => {
      return useMutation(getDeleteMfaMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Email Mfa Method
 */
export const createEmailMfaMethod = (
    mfaMethodEmailCreate: BodyType<MfaMethodEmailCreate>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MfaMethod>(
      {url: `${apiBase()}/auth/mfa/method/email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mfaMethodEmailCreate, signal
    },
      options);
    }




export const getCreateEmailMfaMethodMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailMfaMethod>>, TError,{data: BodyType<MfaMethodEmailCreate>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailMfaMethod>>, TError,{data: BodyType<MfaMethodEmailCreate>}, TContext> => {

const mutationKey = ['createEmailMfaMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailMfaMethod>>, {data: BodyType<MfaMethodEmailCreate>}> = (props) => {
          const {data} = props ?? {};

          return  createEmailMfaMethod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailMfaMethodMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailMfaMethod>>>
    export type CreateEmailMfaMethodMutationBody = BodyType<MfaMethodEmailCreate>
    export type CreateEmailMfaMethodMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Create Email Mfa Method
 */
export const useCreateEmailMfaMethod = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailMfaMethod>>, TError,{data: BodyType<MfaMethodEmailCreate>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmailMfaMethod>>,
        TError,
        {data: BodyType<MfaMethodEmailCreate>},
        TContext
      > => {
      return useMutation(getCreateEmailMfaMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Start Verify Email Mfa Method
 */
export const startVerifyEmailMfaMethod = (
    mfaMethodId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `${apiBase()}/auth/mfa/method/${mfaMethodId}/verify/email/start`, method: 'POST', signal
    },
      options);
    }




export const getStartVerifyEmailMfaMethodMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startVerifyEmailMfaMethod>>, TError,{mfaMethodId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startVerifyEmailMfaMethod>>, TError,{mfaMethodId: string}, TContext> => {

const mutationKey = ['startVerifyEmailMfaMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startVerifyEmailMfaMethod>>, {mfaMethodId: string}> = (props) => {
          const {mfaMethodId} = props ?? {};

          return  startVerifyEmailMfaMethod(mfaMethodId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartVerifyEmailMfaMethodMutationResult = NonNullable<Awaited<ReturnType<typeof startVerifyEmailMfaMethod>>>

    export type StartVerifyEmailMfaMethodMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Start Verify Email Mfa Method
 */
export const useStartVerifyEmailMfaMethod = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startVerifyEmailMfaMethod>>, TError,{mfaMethodId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startVerifyEmailMfaMethod>>,
        TError,
        {mfaMethodId: string},
        TContext
      > => {
      return useMutation(getStartVerifyEmailMfaMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify Email Mfa Method
 */
export const verifyEmailMfaMethod = (
    verifyChallengeRequest: BodyType<VerifyChallengeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VerifiedEnrollmentResponse>(
      {url: `${apiBase()}/auth/mfa/method/verify/email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyChallengeRequest, signal
    },
      options);
    }




export const getVerifyEmailMfaMethodMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmailMfaMethod>>, TError,{data: BodyType<VerifyChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmailMfaMethod>>, TError,{data: BodyType<VerifyChallengeRequest>}, TContext> => {

const mutationKey = ['verifyEmailMfaMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmailMfaMethod>>, {data: BodyType<VerifyChallengeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  verifyEmailMfaMethod(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailMfaMethodMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmailMfaMethod>>>
    export type VerifyEmailMfaMethodMutationBody = BodyType<VerifyChallengeRequest>
    export type VerifyEmailMfaMethodMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Verify Email Mfa Method
 */
export const useVerifyEmailMfaMethod = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmailMfaMethod>>, TError,{data: BodyType<VerifyChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmailMfaMethod>>,
        TError,
        {data: BodyType<VerifyChallengeRequest>},
        TContext
      > => {
      return useMutation(getVerifyEmailMfaMethodMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify Login Mfa Totp
 */
export const verifyLoginMfaTotp = (
    verifyLoginTotpRequest: BodyType<VerifyLoginTotpRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/mfa/totp/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyLoginTotpRequest, signal
    },
      options);
    }




export const getVerifyLoginMfaTotpMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyLoginMfaTotp>>, TError,{data: BodyType<VerifyLoginTotpRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyLoginMfaTotp>>, TError,{data: BodyType<VerifyLoginTotpRequest>}, TContext> => {

const mutationKey = ['verifyLoginMfaTotp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyLoginMfaTotp>>, {data: BodyType<VerifyLoginTotpRequest>}> = (props) => {
          const {data} = props ?? {};

          return  verifyLoginMfaTotp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyLoginMfaTotpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyLoginMfaTotp>>>
    export type VerifyLoginMfaTotpMutationBody = BodyType<VerifyLoginTotpRequest>
    export type VerifyLoginMfaTotpMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Verify Login Mfa Totp
 */
export const useVerifyLoginMfaTotp = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyLoginMfaTotp>>, TError,{data: BodyType<VerifyLoginTotpRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyLoginMfaTotp>>,
        TError,
        {data: BodyType<VerifyLoginTotpRequest>},
        TContext
      > => {
      return useMutation(getVerifyLoginMfaTotpMutationOptions(options), queryClient);
    }
    /**
 * @summary Send Mfa Email Challenge
 */
export const startMfaEmailChallenge = (
    startEmailChallengeRequest: BodyType<StartEmailChallengeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `${apiBase()}/auth/mfa/challenge/email/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startEmailChallengeRequest, signal
    },
      options);
    }




export const getStartMfaEmailChallengeMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMfaEmailChallenge>>, TError,{data: BodyType<StartEmailChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startMfaEmailChallenge>>, TError,{data: BodyType<StartEmailChallengeRequest>}, TContext> => {

const mutationKey = ['startMfaEmailChallenge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMfaEmailChallenge>>, {data: BodyType<StartEmailChallengeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  startMfaEmailChallenge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMfaEmailChallengeMutationResult = NonNullable<Awaited<ReturnType<typeof startMfaEmailChallenge>>>
    export type StartMfaEmailChallengeMutationBody = BodyType<StartEmailChallengeRequest>
    export type StartMfaEmailChallengeMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Send Mfa Email Challenge
 */
export const useStartMfaEmailChallenge = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMfaEmailChallenge>>, TError,{data: BodyType<StartEmailChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startMfaEmailChallenge>>,
        TError,
        {data: BodyType<StartEmailChallengeRequest>},
        TContext
      > => {
      return useMutation(getStartMfaEmailChallengeMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify Login Mfa Email Challenge
 */
export const verifyMfaEmailChallenge = (
    verifyLoginEmailChallengeRequest: BodyType<VerifyLoginEmailChallengeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/mfa/challenge/email/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyLoginEmailChallengeRequest, signal
    },
      options);
    }




export const getVerifyMfaEmailChallengeMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfaEmailChallenge>>, TError,{data: BodyType<VerifyLoginEmailChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMfaEmailChallenge>>, TError,{data: BodyType<VerifyLoginEmailChallengeRequest>}, TContext> => {

const mutationKey = ['verifyMfaEmailChallenge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMfaEmailChallenge>>, {data: BodyType<VerifyLoginEmailChallengeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  verifyMfaEmailChallenge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMfaEmailChallengeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMfaEmailChallenge>>>
    export type VerifyMfaEmailChallengeMutationBody = BodyType<VerifyLoginEmailChallengeRequest>
    export type VerifyMfaEmailChallengeMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Verify Login Mfa Email Challenge
 */
export const useVerifyMfaEmailChallenge = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfaEmailChallenge>>, TError,{data: BodyType<VerifyLoginEmailChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyMfaEmailChallenge>>,
        TError,
        {data: BodyType<VerifyLoginEmailChallengeRequest>},
        TContext
      > => {
      return useMutation(getVerifyMfaEmailChallengeMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify Unused Backup Code
 */
export const verifyUnusedBackupCodes = (
    verifyBackupCodeRequest: BodyType<VerifyBackupCodeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/mfa/backup_code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyBackupCodeRequest, signal
    },
      options);
    }




export const getVerifyUnusedBackupCodesMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyUnusedBackupCodes>>, TError,{data: BodyType<VerifyBackupCodeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyUnusedBackupCodes>>, TError,{data: BodyType<VerifyBackupCodeRequest>}, TContext> => {

const mutationKey = ['verifyUnusedBackupCodes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyUnusedBackupCodes>>, {data: BodyType<VerifyBackupCodeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  verifyUnusedBackupCodes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyUnusedBackupCodesMutationResult = NonNullable<Awaited<ReturnType<typeof verifyUnusedBackupCodes>>>
    export type VerifyUnusedBackupCodesMutationBody = BodyType<VerifyBackupCodeRequest>
    export type VerifyUnusedBackupCodesMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Verify Unused Backup Code
 */
export const useVerifyUnusedBackupCodes = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyUnusedBackupCodes>>, TError,{data: BodyType<VerifyBackupCodeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyUnusedBackupCodes>>,
        TError,
        {data: BodyType<VerifyBackupCodeRequest>},
        TContext
      > => {
      return useMutation(getVerifyUnusedBackupCodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Fresh Until
 */
export const freshUntil = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `${apiBase()}/auth/fresh_until`, method: 'GET', signal
    },
      options);
    }




export const getFreshUntilQueryKey = () => {
    return [
    `${apiBase()}/auth/fresh_until`
    ] as const;
    }


export const getFreshUntilQueryOptions = <TData = Awaited<ReturnType<typeof freshUntil>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof freshUntil>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFreshUntilQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof freshUntil>>> = ({ signal }) => freshUntil(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof freshUntil>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FreshUntilQueryResult = NonNullable<Awaited<ReturnType<typeof freshUntil>>>
export type FreshUntilQueryError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse>


export function useFreshUntil<TData = Awaited<ReturnType<typeof freshUntil>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof freshUntil>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof freshUntil>>,
          TError,
          Awaited<ReturnType<typeof freshUntil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFreshUntil<TData = Awaited<ReturnType<typeof freshUntil>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof freshUntil>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof freshUntil>>,
          TError,
          Awaited<ReturnType<typeof freshUntil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFreshUntil<TData = Awaited<ReturnType<typeof freshUntil>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof freshUntil>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fresh Until
 */

export function useFreshUntil<TData = Awaited<ReturnType<typeof freshUntil>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof freshUntil>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFreshUntilQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Reauth With Password
 */
export const reauthWithPassword = (
    checkPassword: BodyType<CheckPassword>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/reauth/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkPassword, signal
    },
      options);
    }




export const getReauthWithPasswordMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reauthWithPassword>>, TError,{data: BodyType<CheckPassword>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reauthWithPassword>>, TError,{data: BodyType<CheckPassword>}, TContext> => {

const mutationKey = ['reauthWithPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reauthWithPassword>>, {data: BodyType<CheckPassword>}> = (props) => {
          const {data} = props ?? {};

          return  reauthWithPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReauthWithPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof reauthWithPassword>>>
    export type ReauthWithPasswordMutationBody = BodyType<CheckPassword>
    export type ReauthWithPasswordMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Reauth With Password
 */
export const useReauthWithPassword = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reauthWithPassword>>, TError,{data: BodyType<CheckPassword>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reauthWithPassword>>,
        TError,
        {data: BodyType<CheckPassword>},
        TContext
      > => {
      return useMutation(getReauthWithPasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Start Reauth Email Challenge
 */
export const startReauthEmailChallenge = (
    startEmailChallengeRequest: BodyType<StartEmailChallengeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `${apiBase()}/auth/reauth/challenge/email/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startEmailChallengeRequest, signal
    },
      options);
    }




export const getStartReauthEmailChallengeMutationOptions = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startReauthEmailChallenge>>, TError,{data: BodyType<StartEmailChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startReauthEmailChallenge>>, TError,{data: BodyType<StartEmailChallengeRequest>}, TContext> => {

const mutationKey = ['startReauthEmailChallenge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startReauthEmailChallenge>>, {data: BodyType<StartEmailChallengeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  startReauthEmailChallenge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartReauthEmailChallengeMutationResult = NonNullable<Awaited<ReturnType<typeof startReauthEmailChallenge>>>
    export type StartReauthEmailChallengeMutationBody = BodyType<StartEmailChallengeRequest>
    export type StartReauthEmailChallengeMutationError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>

    /**
 * @summary Start Reauth Email Challenge
 */
export const useStartReauthEmailChallenge = <TError = ErrorType<ErrorResponse | InitCustomExceptionCustomInvalidTokenSchema | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startReauthEmailChallenge>>, TError,{data: BodyType<StartEmailChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startReauthEmailChallenge>>,
        TError,
        {data: BodyType<StartEmailChallengeRequest>},
        TContext
      > => {
      return useMutation(getStartReauthEmailChallengeMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify Reauth Email Challenge
 */
export const verifyReauthEmailChallenge = (
    verifyChallengeRequest: BodyType<VerifyChallengeRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuthResponse>(
      {url: `${apiBase()}/auth/reauth/challenge/email/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyChallengeRequest, signal
    },
      options);
    }




export const getVerifyReauthEmailChallengeMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyReauthEmailChallenge>>, TError,{data: BodyType<VerifyChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyReauthEmailChallenge>>, TError,{data: BodyType<VerifyChallengeRequest>}, TContext> => {

const mutationKey = ['verifyReauthEmailChallenge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyReauthEmailChallenge>>, {data: BodyType<VerifyChallengeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  verifyReauthEmailChallenge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyReauthEmailChallengeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyReauthEmailChallenge>>>
    export type VerifyReauthEmailChallengeMutationBody = BodyType<VerifyChallengeRequest>
    export type VerifyReauthEmailChallengeMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Verify Reauth Email Challenge
 */
export const useVerifyReauthEmailChallenge = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyReauthEmailChallenge>>, TError,{data: BodyType<VerifyChallengeRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyReauthEmailChallenge>>,
        TError,
        {data: BodyType<VerifyChallengeRequest>},
        TContext
      > => {
      return useMutation(getVerifyReauthEmailChallengeMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Devices
 */
export const getDevices = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceResponse[]>(
      {url: `${apiBase()}/auth/devices`, method: 'GET', signal
    },
      options);
    }




export const getGetDevicesQueryKey = () => {
    return [
    `${apiBase()}/auth/devices`
    ] as const;
    }


export const getGetDevicesQueryOptions = <TData = Awaited<ReturnType<typeof getDevices>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevices>>> = ({ signal }) => getDevices(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof getDevices>>>
export type GetDevicesQueryError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>


export function useGetDevices<TData = Awaited<ReturnType<typeof getDevices>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevices>>,
          TError,
          Awaited<ReturnType<typeof getDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevices<TData = Awaited<ReturnType<typeof getDevices>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevices>>,
          TError,
          Awaited<ReturnType<typeof getDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevices<TData = Awaited<ReturnType<typeof getDevices>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Devices
 */

export function useGetDevices<TData = Awaited<ReturnType<typeof getDevices>>, TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Revoke All Devices
 */
export const revokeAllDevices = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `${apiBase()}/auth/devices`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeAllDevicesMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAllDevices>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeAllDevices>>, TError,void, TContext> => {

const mutationKey = ['revokeAllDevices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAllDevices>>, void> = () => {


          return  revokeAllDevices(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAllDevicesMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAllDevices>>>

    export type RevokeAllDevicesMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>

    /**
 * @summary Revoke All Devices
 */
export const useRevokeAllDevices = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAllDevices>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeAllDevices>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRevokeAllDevicesMutationOptions(options), queryClient);
    }
    /**
 * @summary Patch Device
 */
export const patchDevice = (
    deviceId: string,
    devicePatch: BodyType<DevicePatch>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeviceResponse>(
      {url: `${apiBase()}/auth/devices/${deviceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: devicePatch, signal
    },
      options);
    }




export const getPatchDeviceMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDevice>>, TError,{deviceId: string;data: BodyType<DevicePatch>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchDevice>>, TError,{deviceId: string;data: BodyType<DevicePatch>}, TContext> => {

const mutationKey = ['patchDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchDevice>>, {deviceId: string;data: BodyType<DevicePatch>}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  patchDevice(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof patchDevice>>>
    export type PatchDeviceMutationBody = BodyType<DevicePatch>
    export type PatchDeviceMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Patch Device
 */
export const usePatchDevice = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDevice>>, TError,{deviceId: string;data: BodyType<DevicePatch>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchDevice>>,
        TError,
        {deviceId: string;data: BodyType<DevicePatch>},
        TContext
      > => {
      return useMutation(getPatchDeviceMutationOptions(options), queryClient);
    }
    /**
 * @summary Revoke Device
 */
export const revokeDevice = (
    deviceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `${apiBase()}/auth/devices/${deviceId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeDeviceMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeDevice>>, TError,{deviceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeDevice>>, TError,{deviceId: string}, TContext> => {

const mutationKey = ['revokeDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeDevice>>, {deviceId: string}> = (props) => {
          const {deviceId} = props ?? {};

          return  revokeDevice(deviceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof revokeDevice>>>

    export type RevokeDeviceMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Revoke Device
 */
export const useRevokeDevice = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeDevice>>, TError,{deviceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeDevice>>,
        TError,
        {deviceId: string},
        TContext
      > => {
      return useMutation(getRevokeDeviceMutationOptions(options), queryClient);
    }
    /**
 * @summary Reset Mfa
 */
export const resetMfa = (
    params: ResetMfaParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `${apiBase()}/auth/mfa/reset`, method: 'POST',
        params, signal
    },
      options);
    }




export const getResetMfaMutationOptions = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMfa>>, TError,{params: ResetMfaParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetMfa>>, TError,{params: ResetMfaParams}, TContext> => {

const mutationKey = ['resetMfa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetMfa>>, {params: ResetMfaParams}> = (props) => {
          const {params} = props ?? {};

          return  resetMfa(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetMfaMutationResult = NonNullable<Awaited<ReturnType<typeof resetMfa>>>

    export type ResetMfaMutationError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>

    /**
 * @summary Reset Mfa
 */
export const useResetMfa = <TError = ErrorType<InitCustomExceptionCustomInvalidTokenSchema | ErrorResponse | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMfa>>, TError,{params: ResetMfaParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetMfa>>,
        TError,
        {params: ResetMfaParams},
        TContext
      > => {
      return useMutation(getResetMfaMutationOptions(options), queryClient);
    }
